<script>
// import Vue from 'vue'
// Import UI components
import Layout from '@layouts/report.vue'
import Grid from '@components/grid.vue'


// Import ThirdParty UI Components
import basicPieChart from '@components/charts/basicPieChart.vue'
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
// Import Deps
import axios from 'axios'
import moment from 'moment'
// import _ from 'underscore'

// Import helpers
// import { sortData, pipe } from '@utils/helpers.js'

// export const remapData = (data) =>
//   data.map((obj, index) => {
//     return { value: obj[key1], name: obj[key2] }
//   })

export const pipe = (...functions) => (value) => {
  return functions.reduce((currentValue, currentFunction) => {
    return currentFunction(currentValue)
  }, value)
}

const key1Options = [
  'TotalFirst',
  'TotalBusiness',
  'TotalEconomy',
  'TotalMale',
  'TotalFemale',
  'TotalChild',
  'TotalInfant',
  'TotalRes',
  'TotalCkd',
  'TotalBrd',
  'TotalSby',
  'TotalEtkt',
  'TotalWebChecked',
]

const filterObj = {
  filter: 'agTextColumnFilter',
  filterParams: {
    applyButton: false,
    resetButton: true,
  },
  resizable: true,
  sortable: true,
}

const sortData = (data) =>
  data.sort((a, b) => {
    var x = a.value
    var y = b.value
    return x < y ? -1 : x > y ? 1 : 0
  })

export default {
  page() {},
  components: {
    Layout,
    Grid,
    basicPieChart,
    Loading,
  },
  props: {
    key1: {
      type: String,
      required: true,
    },
    key2: { type: String, required: true },
    key2plural: {
      type: String,
      required: true,
    },
    routeKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      columnDefs: [
        {
          field: this.key2,
          pinned: true,
          cellClass: 'text-center',
          valueFormatter: (params) => {
            return params.value ? params.value : ' - '
          },
          ...filterObj,
        },
        {
          headerName: 'By Cabin Class',
          children: [
            { field: 'TotalFirst', headerName: 'F', ...filterObj },
            { field: 'TotalBusiness', headerName: 'C', ...filterObj },
            { field: 'TotalEconomy', headerName: 'Y', ...filterObj },
          ],
        },
        {
          headerName: 'By Passenger Type',
          children: [
            { field: 'TotalMale', headerName: 'M', ...filterObj },
            { field: 'TotalFemale', headerName: 'F', ...filterObj },
            { field: 'TotalChild', headerName: 'C', ...filterObj },
            { field: 'TotalInfant', headerName: 'I', ...filterObj },
          ],
        },
        {
          headerName: 'By Status',
          children: [
            {
              field: 'TotalRes',
              headerName: 'Bkd',
              columnGroupShow: 'open',
              width: 80,
              ...filterObj,
            },
            {
              field: 'TotalCkd',
              headerName: 'Ckd',
              columnGroupShow: 'open',
              width: 80,
              ...filterObj,
            },
            {
              field: 'TotalBrd',
              headerName: 'Brd',
              columnGroupShow: 'both',
              sort: 'desc',
              width: 80,
              ...filterObj,
            },
            {
              field: 'TotalSby',
              headerName: 'Sby',
              columnGroupShow: 'open',
              width: 80,
              ...filterObj,
            },
          ],
        },
        {
          headerName: 'Other',
          children: [
            { field: 'TotalEtkt', headerName: 'Etkt', ...filterObj },
            { field: 'TotalWebChecked', headerName: 'Web', ...filterObj },
          ],
        },
      ],
      gridData: [],
      paxData: [],
      chart1Data: [],
      chart2Data: [],
      lastUpdated: [{ type: 'paxdata', timestamp: null }],
      isLoading: false,
      error: null,
      sideBarVisible: true,
      natFilter: null,
      key1Options: key1Options,

      othersLimit: null,
      params: {},
      paramsSchema: [
        {
          fieldType: 'MultiSelect',
          placeholder: 'Select Carriers',
          multi: true,
          value: null,
          name: 'carrier',
          label: 'Carriers',
        },
      ],
    }
  },

  computed: {
    exportParams() {
      return {
        fileName: `PaxTotalBy${this.key2}-${moment(
          this.dateRange.startDate
        ).format('DDMMMYY')}_${moment(this.dateRange.endDate).format(
          'DDMMMYY'
        )}.csv`,
        suppressQuotes: false,
        columnSeparator: ',',
      }
    },

    carrierChoice() {
      return this.$store.getters['auth/getCarrierChoice']
    },
    dateRange() {
      return this.$store.getters['report/getSelectedDateRange']
    },
    userFriendlyKey1() {
      return this.key1.replace(/([A-Z])/g, ' $1').trim()
    },
    chart1Title() {
      return `${this.key2plural} by ${this.userFriendlyKey1} Passengers`
    },
    chart1SubTitle() {
      return `Showing all data.`
    },
    chart2SubTitle() {
      return `Showing all data with the top 1 result(s) removed.`
    },
    chartHelper() {
      return `${this.key2plural} where ${
        this.userFriendlyKey1
      } passengers is less than ${
        this.othersLimit ? this.othersLimit.toFixed() : 0
      } are grouped in 'others'.`
    },
  },
  watch: {
    key1() {
      this.getData()
    },
    dateRange: {
      deep: true,
      immediate: true,
      handler(dateRange) {
        this.getData()
      },
    },
    params: {
      deep: true,
      handler() {
        this.getData()
      },
    },
  },
  beforeCreate() {
    this.$store.dispatch('report/SET_SELECTED_DATE_RANGE', {
      startDate: moment().add(-1, 'month'),
      endDate: moment().add(-1, 'd'),
    })
  },
  mounted() {
    // this.getData()
    this.paramsSchema[0].options = this.carrierChoice
  },
  methods: {
    csvExport() {
      this.$refs.grid.onBtnExport(this.exportParams)
    },
    moment(date, format) {
      return moment(date).format(format)
    },
    sortData(data) {
      return data.sort((a, b) => {
        var x = a[this.sortKey]
        var y = b[this.sortKey]
        return x < y ? -1 : x > y ? 1 : 0
      })
    },
    processPieData(data) {
      // Create a var to sum all the records we are moving into the
      // 'others' group.
      let _others = 0
      //  Get an average of the current data set
      //   This will be used to move records into the 'others' group
      const _othersLimit =
        data.reduce((memo, obj) => memo + obj[this.key1], 0) / data.length || 1
      //   Divide the average by 2 in order to create an 'others' group that
      // contains all the records with small values
      this.othersLimit = _othersLimit / 2
      //   Create a new array that will contain records that are above
      // the othersLimit value
      const newArray = []
      //   Loop through the data set keep rocrds thats are above x and reducing everyting
      // else into the 'others' group
      //   Data format required for eCharts Pie is {name: 'XXX', value: xxx}

      for (let index = 0; index < data.length; index++) {
        if (data[index][this.key1] < this.othersLimit) {
          _others = _others + data[index][this.key1]
        } else {
          newArray.push({
            value: data[index][this.key1],
            name:
              data[index][this.key2] == null
                ? 'No ' + this.key2
                : data[index][this.key2],
          })
        }
      }
      //   Push the newly created _others value into the charts array.
      if (_others > 0) {
        newArray.push({
          value: _others,
          name: 'Others',
        })
      }
      return newArray
    },
    getData() {
      this.isLoading = true

      this.error = null
      //   Setup Report Params
      const startDate = moment(this.dateRange.startDate).format('DDMMMYY')
      const endDate = moment(this.dateRange.endDate).format('DDMMMYY')
      const carriers =
        this.params && this.params.carrier
          ? this.params.carrier.join(',')
          : 'all'
      //   @@TODO - Config file for webapi address!!
      axios
        .get(
          `${this.$config.apiBaseUrl}paxTotals/${this.routeKey}/carrier/${carriers}/start/${startDate}/end/${endDate}`
        )
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const paxlist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'paxdata'
          )
          this.lastUpdated[paxlist].timestamp = response.data.Timestamp
          // There is no ID in this data set use and index value instead
          // This is required for AG-GRID
          data.forEach((element, index) => {
            element.id = index
          })
          // Assign the data from the response to reactive var

          this.paxData = sortData(data).reverse()
          let newArray = []
          if (data.length < 10) {
            newArray = data.map((obj) => {
              return { name: obj[this.key2], value: obj[this.key1] }
            })
          } else {
            newArray = this.processPieData(data)
          }

          // Assign the chart data to the reactive chart1Data var
          this.chart1Data = pipe(sortData)(newArray).reverse()
          // Assign the chart data to the reactive chart2Data var (removing top values with splice)
          this.chart2Data = pipe(sortData)(newArray)
            .reverse()
            .slice(1, newArray.length)
        })
        .catch((error) => {
          this.error = error.response
          console.log('here ---> ', error)
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <Layout
    :params-schema="paramsSchema"
    :params="params"
    :last-updated="lastUpdated"
    :error="error"
  >
    <div class="content-container">
      <div
        v-if="sideBarVisible"
        id="sidebar-collapse"
        class="sidebar lg collapse pos-rel text-right"
      >
        <div class="sidebar-content container">
          <div class="app-sidebar text-small">
            <Loading
              :active.sync="isLoading"
              :opacity="0.75"
              :can-cancel="false"
              :is-full-page="false"
            >
              <template slot:default>
                <div class="loading-small">Loading...</div>
              </template>
            </Loading>
            <div class="app-sidebar-top">
              <b-form-select
                v-model="key1"
                plain
                :options="key1Options"
                class="mb-1  form-control form-control-xs"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled
                    >-- Please select an option --</b-form-select-option
                  >
                </template>
              </b-form-select>
            </div>
            <basicPieChart
              :chart-data="chart1Data"
              :chart-title="chart1Title"
              :chart-sub-title="chart1SubTitle"
            />
            <basicPieChart
              :chart-data="chart2Data"
              :chart-title="chart1Title"
              :chart-sub-title="chart2SubTitle"
            />
            <div class="app-sidebar-bottom text-center text-muted">
              <small>{{ chartHelper }}</small>
            </div>
          </div>
        </div>
      </div>

      <div class="chat-module pos-rel" data-filter-list="chat-module-body">
        <Loading
          :active.sync="isLoading"
          :opacity="0.75"
          :can-cancel="false"
          :is-full-page="false"
        >
          <template slot:default>
            <div class="loading-small">Loading...</div>
          </template>
        </Loading>
        <div class="toolbar row p-2">
          <div class="col-4">
            <input
              v-model="natFilter"
              class="form-control form-control-sm"
              type="text"
              placeholder="Nationality Search"
            />
          </div>
          <button
            class="btn btn-sm btn-primary mr-2"
            :disabled="isLoading"
            @click="getData($route.params.flightId)"
            >{{ isLoading ? 'Refreshing...' : 'Refresh' }}</button
          >
          <b-dropdown
            v-if="$resize && $mq.above(992)"
            text="Export"
            variant="primary"
            size="sm"
            class
          >
            <b-dropdown-item :disabled="isLoading" @click="csvExport">
              <b-icon icon="cloud-download" class="mr-1"></b-icon>Download CSV
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <Grid
          :ref="'grid'"
          :column-defs="columnDefs"
          :grid-data="paxData"
          :filter="natFilter"
          filter-col="Nationality"
          :resize-headers="false"
        />
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.toolbar {
  background: #f5f7f7;
}
.totals-row {
  display: flex;
  justify-content: space-evenly;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.flight-status.FINALIZED {
  background: #1c2b36;
  padding: 1px 5px;
  border-radius: 2px;
  color: white;
}

.text-lg {
  font-size: 1.2rem;
}

.echarts {
  height: 300px;
}
</style>
